import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MerchantService } from 'src/app/services/merchant/merchant.service';
import {
  Colores, coloresAlNucleo, coloresDe, contraste, CREDITOTAL, DE_LA_LISTA, hexDe, Juegos, juegosDe, mismosColores, ModeloIngreso, NOMBRE_PRESET,
  opcionesBarra, opcionesFondo, opcionesPanel, TemaGuardado, temaDeLaLista,
  O, oDe, Preset, PRINCIPAL, Propuesta, proponerAcentos, proponerBases, RESERVADAS, sobre, temaGuardado,
  temaParaGuardar, Tokens, zona,
} from 'src/app/services/tema/motor-tema';

type Clave = 'principal' | 'acento' | 'base' | 'barra' | 'fondo' | 'panel';
interface Celda { fg: string; bg: string; ratio: string; nivel: 'bien' | 'justo' | 'mal'; }
interface Prueba { etq: string; claro: Celda; oscuro: Celda; }
interface Nota { aviso: boolean; texto: string; }
interface Punto { x: number; y: number; color: string; }

/* Los íconos del portal en miniatura (lucide, los mismos del portal), en trazos para *ngFor:
   Angular limpia el SVG que entra por innerHTML, así que se dibujan con [attr.d]. */
const rect = (x: number, y: number, w: number, h: number, r: number): string =>
  `M${x + r} ${y}h${w - 2 * r}a${r} ${r} 0 0 1 ${r} ${r}v${h - 2 * r}a${r} ${r} 0 0 1-${r} ${r}h-${w - 2 * r}a${r} ${r} 0 0 1-${r}-${r}v-${h - 2 * r}a${r} ${r} 0 0 1 ${r}-${r}z`;
const circ = (cx: number, cy: number, r: number): string => `M${cx - r} ${cy}a${r} ${r} 0 1 0 ${2 * r} 0a${r} ${r} 0 1 0-${2 * r} 0`;
const ICONOS: Record<string, string[]> = {
  store: ['m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7', 'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8', 'M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4', 'M2 7h20', 'M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7'],
  resumen: [rect(3, 3, 7, 9, 1), rect(14, 3, 7, 5, 1), rect(14, 12, 7, 9, 1), rect(3, 16, 7, 5, 1)],
  comercio: ['M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z', 'M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2', 'M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2', 'M10 6h4', 'M10 10h4', 'M10 14h4', 'M10 18h4'],
  cajas: [rect(4, 2, 16, 20, 2), 'M8 6h8', 'M16 14v4', 'M16 10h.01', 'M12 10h.01', 'M8 10h.01', 'M12 14h.01', 'M8 14h.01', 'M12 18h.01', 'M8 18h.01'],
  codigos: ['M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z', circ(16.5, 7.5, 0.5)],
  cierre: ['M8 2v4', 'M16 2v4', rect(3, 4, 18, 18, 2), 'M3 10h18', 'm9 16 2 2 4-4'],
  ordenes: ['M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8', 'M3 3v5h5', 'M12 7v5l4 2'],
  ventas: ['M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z', 'M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8', 'M12 17.5v-11'],
  liquidaciones: ['M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1', 'M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4'],
  panel: [rect(3, 3, 18, 18, 2), 'M9 3v18'],
  subebaja: ['m7 15 5 5 5-5', 'm7 9 5-5 5 5'],
  luna: ['M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z'],
  buscar: [circ(11, 11, 8), 'm21 21-4.3-4.3'],
  bajar: ['M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', 'M7 10l5 5 5-5', 'M12 15V3'],
};

/**
 * «TEMAS» — la solapa de la ficha del comercio, `console/merchants/:code/temas`.
 *
 * Juan, 2026-09-25: *«el tema lo decide [CrediTotal] por comercio… en una nueva opción Temas en
 * comercio dentro del user, y se aplica ese tema en el comercio cuando se loguea»*. Diseño aprobado
 * sobre el prototipo publicado (claude.ai/artifact/BzWKzVYwSbPgu23teDyZnu), con el CrediTotal 2 que
 * pidió después: la barra lateral en cian sólido.
 *
 * Cuatro temas: Principal (el negro de hoy, el de todos), CrediTotal, CrediTotal 2 y Personalizado
 * (das un color y el motor propone los otros dos). La letra la escoge el motor por contraste, y la
 * vista previa pinta el portal con los MISMOS tokens que se guardan.
 *
 * 🔴 Es RUTA HIJA de la ficha: la miga, el nombre y las solapas los pone el padre.
 * 🔴 Guarda con `PUT /api/merchant/:code` (sólo CrediTotal). El núcleo valida la forma en
 *    `helpers/tema-comercio.js`; el portal lo lee de la ficha que ya pide al entrar.
 */
@Component({
  selector: 'app-comercios-temas',
  templateUrl: './comercios-temas.component.html',
  styleUrls: ['./comercios-temas.component.css']
})
export class ComerciosTemasComponent implements OnInit, OnDestroy {

  codigo = '';
  nombre = '';
  cargando = true;
  error: string | null = null;

  preset: Preset = 'principal';
  colores: Colores = { ...CREDITOTAL };
  guardado: { preset: Preset; colores: Colores; logo: string | null; login: ModeloIngreso } = { preset: 'principal', colores: { ...CREDITOTAL }, logo: null, login: 'columnas' };
  /** El modelo del ingreso (Juan, 2026-09-25): los tres salen de bloques de shadcn. */
  login: ModeloIngreso = 'columnas';
  readonly MODELOS: { valor: ModeloIngreso; titulo: string; bloque: string; desc: string }[] = [
    { valor: 'columnas', titulo: 'Dos columnas', bloque: 'login-02', desc: 'El de siempre: el panel a un lado y el formulario al otro.' },
    { valor: 'dividida', titulo: 'Tarjeta dividida', bloque: 'login-04', desc: 'Una tarjeta con el formulario y el panel lado a lado. En el teléfono, la tarjeta sobre el color del panel.' },
    { valor: 'minimal', titulo: 'Minimalista', bloque: 'login-01', desc: 'Sólo la tarjeta del formulario, al centro, con los logos chicos arriba.' },
  ];
  /** El logo del comercio (imagen embebida de 256 px), o `null`: la barra muestra la casita. */
  logo: string | null = null;
  modoLogo: 'ajustar' | 'llenar' = 'ajustar';
  errorLogo: string | null = null;
  /** La imagen recién subida, para rehacer el recorte al cambiar de «ajustar» a «llenar». */
  private imagenSubida: HTMLImageElement | null = null;
  acentoManual = true;
  baseManual = true;
  iAcento = 0;
  iBase = 0;

  juegos: Juegos = juegosDe('principal', PRINCIPAL.colores);
  estiloClaro = '';
  estiloOscuro = '';
  acentos: Propuesta[] = [];
  bases: Propuesta[] = [];
  pruebas: Prueba[] = [];
  notas: Nota[] = [];
  hex: Record<Clave, string> = { principal: '', acento: '', base: '', barra: '', fondo: '', panel: '' };
  visibles: Record<Clave, string> = { principal: '', acento: '', base: '', barra: '', fondo: '', panel: '' };
  tonos: Record<Clave, string> = { principal: '', acento: '', base: '', barra: '', fondo: '', panel: '' };
  atajosPanel: Propuesta[] = [];
  iPanel = -1;
  atajosBarra: Propuesta[] = [];
  iBarra = -1;
  atajosFondo: Propuesta[] = [];
  iFondo = -1;
  private enfocado: Clave | null = null;

  vista: 'claro' | 'comparar' | 'oscuro' = 'comparar';
  corte = 50;
  /** El portal en miniatura se dibuja a 800 px y se escala al ancho que haya: dentro de la ficha
   *  la columna es más angosta que la página, y cortarlo o darle barra horizontal esconde la mitad. */
  escala = 1;
  private observador?: ResizeObserver;
  @ViewChild('marco') set marcoRef(el: ElementRef<HTMLElement> | undefined) {
    this.observador?.disconnect();
    if (!el) return;
    this.observador = new ResizeObserver(([e]) => {
      const escala = Math.min(1, e.contentRect.width / 800);
      if (Math.abs(escala - this.escala) > 0.005) this.zona.run(() => { this.escala = escala; });
    });
    this.observador.observe(el.nativeElement);
  }

  readonly anillo: string;
  marcas: { d: string; clase: string }[] = [];
  puntoP: Punto | null = null;
  puntoA: Punto | null = null;
  tono = '—';
  tonoValor = 0;

  guardando = false;
  resultado: { ok: boolean; texto: string } | null = null;

  /** La lista de temas guardados (para todos los comercios). */
  temasGuardados: TemaGuardado[] = [];
  errorLista: string | null = null;
  /** El tema guardado que coincide con los colores de ahora, o `null`. */
  idGuardadoActivo: string | null = null;
  nombreNuevo = '';
  guardandoEnLista = false;
  resultadoLista: { ok: boolean; texto: string } | null = null;
  /** Confirmación en el mismo lugar, sin ventana: el id que se está por eliminar. */
  porEliminar: string | null = null;
  eliminando = false;

  readonly ICONOS = ICONOS;
  readonly NOMBRE_PRESET = NOMBRE_PRESET;
  readonly OPCIONES: { valor: Preset; titulo: string; desc: string; muestras: string[] }[] = [
    { valor: 'principal', titulo: 'Principal', desc: 'El negro de hoy, el que tienen todos.', muestras: ['#171717', '#FAFAFA', '#E5E5E5'] },
    { valor: 'creditotal', titulo: 'CrediTotal', desc: 'Los colores de la app: cian y naranja, con la barra y el ingreso en negro.', muestras: ['#37B0C9', '#F5A302', '#0A0A0A'] },
    { valor: 'creditotal-2', titulo: 'CrediTotal 2', desc: 'Los mismos colores, con la barra lateral en cian.', muestras: ['#37B0C9', '#F5A302', '#040C22'] },
    { valor: 'personalizado', titulo: 'Personalizado', desc: 'Das un color y te proponemos los otros dos.', muestras: [] },
  ];
  readonly MENU = [['resumen', 'Resumen'], ['comercio', 'Mi comercio'], ['cajas', 'Cajas'], ['codigos', 'Códigos'], ['cierre', 'Cierre de caja'], ['ordenes', 'Órdenes'], ['ventas', 'Ventas'], ['liquidaciones', 'Liquidaciones']];
  readonly FILAS = [['2419', 'María Rondón', '$120,00', 'ok', 'Cobrada'], ['2418', 'José Medina', '$85,00', 'aviso', 'Esperando la firma'], ['2417', 'Carla Brito', '$240,00', 'ok', 'Cobrada'], ['2416', 'Luis Pacheco', '$45,00', 'malo', 'Anulada']];

  private sub?: Subscription;

  constructor(private ruta: ActivatedRoute, private _merchant: MerchantService, public _auth: AuthService, private zona: NgZone) {
    const paradas: string[] = [];
    for (let h = 0; h <= 360; h += 15) paradas.push(`${hexDe(O(0.72, 0.14, h))} ${h}deg`);
    this.anillo = `conic-gradient(from 0deg, ${paradas.join(',')})`;
    const clase: Record<number, string> = { 25: 'kb-texto-peligro', 75: 'kb-texto-alerta', 155: 'kb-texto-exito' };
    this.marcas = RESERVADAS.map((z) => ({ d: this.arco(z.h - z.ancho, z.h + z.ancho, 64), clase: clase[z.h] }));
    this.recalcular();
  }

  ngOnInit(): void {
    this.sub = this.ruta.paramMap.subscribe((p) => {
      this.codigo = (p.get('code') || '').toUpperCase();
      this.cargar();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.observador?.disconnect();
  }

  // RBAC (2026-10-06): el tema tiene su propio permiso, config.comercios_temas.update.
  get puedeEditar(): boolean { return this._auth.hasPermission('config.comercios_temas.update'); }
  get personalizado(): boolean { return this.preset === 'personalizado'; }
  get sinCambios(): boolean {
    if ((this.logo || null) !== (this.guardado.logo || null)) return false;
    if (this.login !== this.guardado.login) return false;
    if (this.preset !== this.guardado.preset) return false;
    if (this.preset === 'principal') return true;
    return (['principal', 'acento', 'base', 'barra', 'fondo', 'panel'] as const).every((k) => this.colores[k] === this.guardado.colores[k]);
  }

  cargar = async (): Promise<void> => {
    this.cargando = true;
    this.error = null;
    try {
      const [rep] = await Promise.all([this._merchant.getMerchant(this.codigo), this.cargarLista()]);
      const m = rep?.merchant;
      if (!m) throw new Error('El comercio no existe');
      this.nombre = m.name || this.codigo;
      this.guardado = temaGuardado(m.theme);
      this.preset = this.guardado.preset;
      this.colores = { ...this.guardado.colores };
      this.logo = this.guardado.logo;
      this.login = this.guardado.login;
      this.acentoManual = true;
      this.baseManual = true;
      this.recalcular();
    } catch (e: any) {
      this.error = e?.error?.msg || e?.message || 'Error desconocido';
    } finally {
      this.cargando = false;
    }
  };

  // ───────────────────────────────────────────────────────────── el logo del comercio
  /**
   * Juan, 2026-09-25: «una sección en el tema para cargar el logo… o el ícono». Se recorta aquí a un
   * cuadrado de 256 px y viaja embebido en el tema (el núcleo acepta PNG o WebP de hasta ~90 KB).
   * «Ajustar» deja la imagen entera con aire; «Llenar» la agranda hasta cubrir el cuadro.
   */
  subirLogo(ev: Event): void {
    const input = ev.target as HTMLInputElement;
    const archivo = input.files && input.files[0];
    input.value = '';
    if (!archivo || !this.puedeEditar) return;
    this.errorLogo = null;
    if (!/^image\/(png|jpeg|webp|svg\+xml)$/.test(archivo.type)) { this.errorLogo = 'Sube una imagen PNG, JPG, WebP o SVG.'; return; }
    if (archivo.size > 8 * 1024 * 1024) { this.errorLogo = 'La imagen pesa más de 8 MB.'; return; }
    const lector = new FileReader();
    lector.onload = () => {
      const img = new Image();
      img.onload = () => { this.imagenSubida = img; this.recortarLogo(); };
      img.onerror = () => { this.errorLogo = 'No se pudo leer esa imagen.'; };
      img.src = String(lector.result);
    };
    lector.readAsDataURL(archivo);
  }

  ponerModoLogo(modo: 'ajustar' | 'llenar'): void {
    this.modoLogo = modo;
    if (this.imagenSubida) this.recortarLogo();
  }

  private recortarLogo(): void {
    const img = this.imagenSubida;
    if (!img) return;
    const lado = 256;
    const lienzo = document.createElement('canvas');
    lienzo.width = lado; lienzo.height = lado;
    const ctx = lienzo.getContext('2d');
    if (!ctx) { this.errorLogo = 'El navegador no pudo preparar la imagen.'; return; }
    const w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    const escala = this.modoLogo === 'llenar' ? Math.max(lado / w, lado / h) : Math.min((lado * 0.84) / w, (lado * 0.84) / h);
    const dw = w * escala, dh = h * escala;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, (lado - dw) / 2, (lado - dh) / 2, dw, dh);
    let url = lienzo.toDataURL('image/webp', 0.92);
    if (!url.startsWith('data:image/webp')) url = lienzo.toDataURL('image/png');
    for (let q = 0.85; url.length > 115000 && q >= 0.5; q -= 0.1) url = lienzo.toDataURL('image/webp', q);
    if (url.length > 115000) { this.errorLogo = 'La imagen quedó muy pesada aun achicada. Prueba con una más simple.'; return; }
    this.logo = url;
    this.resultado = null;
  }

  elegirModelo(m: ModeloIngreso): void {
    if (!this.puedeEditar) return;
    this.login = m;
    this.resultado = null;
  }

  quitarLogo(): void {
    if (!this.puedeEditar) return;
    this.logo = null;
    this.imagenSubida = null;
    this.errorLogo = null;
    this.resultado = null;
  }

  // ───────────────────────────────────────────────────────────── la lista de temas guardados
  private cargarLista = async (): Promise<void> => {
    try {
      const r = await this._merchant.listarTemasGuardados();
      this.temasGuardados = (r?.temas || []).map(temaDeLaLista);
      this.errorLista = null;
    } catch (e: any) {
      this.temasGuardados = [];
      this.errorLista = e?.error?.msg || 'No se pudo leer la lista de temas guardados.';
    }
  };

  elegirGuardado(t: TemaGuardado): void {
    if (!this.puedeEditar) return;
    this.resultado = null;
    this.porEliminar = null;
    this.preset = 'personalizado';
    this.colores = { ...t.colores };
    this.acentoManual = true; this.baseManual = true;
    this.recalcular();
  }

  guardarEnLista = async (): Promise<void> => {
    const nombre = this.nombreNuevo.trim();
    if (!this.puedeEditar || this.guardandoEnLista || nombre.length < 2) return;
    this.guardandoEnLista = true;
    this.resultadoLista = null;
    try {
      const r = await this._merchant.guardarTemaGuardado(nombre, coloresAlNucleo(this.colores));
      this.temasGuardados = [...this.temasGuardados, temaDeLaLista(r.tema)].sort((a, b) => a.name.localeCompare(b.name, 'es'));
      this.nombreNuevo = '';
      this.resultadoLista = { ok: true, texto: `«${r.tema.name}» quedó en la lista. Sirve para cualquier comercio.` };
      this.recalcular();
    } catch (e: any) {
      this.resultadoLista = { ok: false, texto: e?.error?.msg || 'No se pudo guardar el tema.' };
    } finally {
      this.guardandoEnLista = false;
    }
  };

  pedirEliminar(ev: Event, t: TemaGuardado): void {
    ev.preventDefault(); ev.stopPropagation();
    this.porEliminar = t._id;
  }
  cancelarEliminar(ev: Event): void {
    ev.preventDefault(); ev.stopPropagation();
    this.porEliminar = null;
  }
  eliminarGuardado = async (ev: Event, t: TemaGuardado): Promise<void> => {
    ev.preventDefault(); ev.stopPropagation();
    if (!this.puedeEditar || this.eliminando) return;
    this.eliminando = true;
    try {
      await this._merchant.eliminarTemaGuardado(t._id);
      this.temasGuardados = this.temasGuardados.filter((x) => x._id !== t._id);
      this.resultadoLista = { ok: true, texto: `«${t.name}» salió de la lista. Los comercios que ya lo usan no cambian.` };
      this.porEliminar = null;
      this.recalcular();
    } catch (e: any) {
      this.resultadoLista = { ok: false, texto: e?.error?.msg || 'No se pudo eliminar el tema.' };
    } finally {
      this.eliminando = false;
    }
  };

  // ───────────────────────────────────────────────────────────── escoger
  elegir(valor: Preset): void {
    if (!this.puedeEditar) return;
    this.resultado = null;
    if (valor === 'personalizado') this.aPersonalizado();
    else {
      this.preset = valor;
      if (valor !== 'principal') this.colores = { ...DE_LA_LISTA[valor] };
    }
    this.recalcular();
  }

  /**
   * CLONAR — Juan, 2026-09-25: *«yo puedo clonar hacia personalizado cualquiera de los que tengo»*.
   * Copia los colores del tema escogido TAL CUAL (el Principal también, con su negro) y deja que
   * se cambie sólo lo que se quiera. Cambiar un color de un tema de la lista también clona.
   */
  private aPersonalizado(): void {
    if (this.preset === 'personalizado') return;
    this.colores = coloresDe(this.preset);
    this.acentoManual = true; this.baseManual = true;
    this.preset = 'personalizado';
  }

  clonar(): void {
    if (!this.puedeEditar) return;
    this.resultado = null;
    this.aPersonalizado();
    this.recalcular();
  }

  private ponerPrincipal(hex: string): void {
    this.aPersonalizado();
    this.colores.principal = hex;
    if (!this.acentoManual) this.colores.acento = proponerAcentos(hex)[this.iAcento].hex;
    if (!this.baseManual) this.colores.base = proponerBases(hex)[this.iBase].hex;
  }

  ponerColor(clave: Clave, valor: string): void {
    if (!this.puedeEditar) return;
    const hex = valor.toUpperCase();
    if (clave === 'principal') this.ponerPrincipal(hex);
    else {
      this.aPersonalizado();
      this.colores[clave] = hex;
      if (clave === 'acento') this.acentoManual = true; else if (clave === 'base') this.baseManual = true;
    }
    this.editado();
  }

  escribirHex(clave: Clave, ev: Event): void {
    const v = ((ev.target as HTMLInputElement).value || '').trim();
    this.hex[clave] = v;
    if (/^#?[0-9a-fA-F]{6}$/.test(v)) this.ponerColor(clave, '#' + v.replace('#', ''));
  }
  enfocar(clave: Clave | null): void { this.enfocado = clave; if (!clave) this.recalcular(); }

  elegirAcento(i: number): void {
    if (!this.puedeEditar) return;
    this.iAcento = i; this.acentoManual = false;
    this.colores.acento = this.acentos[i].hex;
    this.editado();
  }
  elegirBase(i: number): void {
    if (!this.puedeEditar) return;
    this.iBase = i; this.baseManual = false;
    this.colores.base = this.bases[i].hex;
    this.editado();
  }
  ponerPanel(hex: string): void {
    if (!this.puedeEditar) return;
    this.aPersonalizado();
    this.colores.panel = hex;
    this.editado();
  }
  ponerFondo(hex: string): void {
    if (!this.puedeEditar) return;
    this.aPersonalizado();
    this.colores.fondo = hex;
    this.editado();
  }
  ponerBarra(hex: string): void {
    if (!this.puedeEditar) return;
    this.aPersonalizado();
    this.colores.barra = hex;
    this.editado();
  }

  /** Si lo que quedó escogido es igual a un tema de la lista, se marca ése. */
  private editado(): void {
    this.resultado = null;
    if (this.preset === 'personalizado') {
      for (const k of ['principal', 'creditotal', 'creditotal-2'] as const) {
        const p = coloresDe(k);
        if ((['principal', 'acento', 'base', 'barra', 'fondo', 'panel'] as const).every((x) => p[x] === this.colores[x])) { this.preset = k; break; }
      }
    }
    this.recalcular();
  }

  // ───────────────────────────────────────────────────────────── la rueda
  private punto(h: number, r: number): [number, number] {
    const a = (h - 90) * Math.PI / 180;
    return [66 + r * Math.cos(a), 66 + r * Math.sin(a)];
  }
  private arco(h1: number, h2: number, r: number): string {
    const [x1, y1] = this.punto(h1, r), [x2, y2] = this.punto(h2, r);
    return `M${x1.toFixed(2)} ${y1.toFixed(2)} A${r} ${r} 0 0 1 ${x2.toFixed(2)} ${y2.toFixed(2)}`;
  }
  private colorVisible(clave: Clave): string {
    return this.preset === 'principal' ? PRINCIPAL.colores[clave] : this.colores[clave];
  }
  private rotar(h: number): void {
    const p = oDe(this.colorVisible('principal'));
    const l = p.c < 0.03 ? 0.6 : p.l, c = p.c < 0.03 ? 0.15 : p.c;
    this.ponerPrincipal(hexDe(O(l, c, h)));
    this.editado(); // recalcular cuesta menos de un milisegundo: no hace falta agrupar movimientos
  }
  private tonoDesde(ev: PointerEvent): number {
    const r = (ev.currentTarget as HTMLElement).getBoundingClientRect();
    let h = Math.atan2(ev.clientX - (r.left + r.width / 2), -(ev.clientY - (r.top + r.height / 2))) * 180 / Math.PI;
    if (h < 0) h += 360;
    return h;
  }
  ruedaAbajo(ev: PointerEvent): void {
    if (!this.puedeEditar) return;
    (ev.currentTarget as HTMLElement).setPointerCapture(ev.pointerId);
    this.rotar(this.tonoDesde(ev));
  }
  ruedaMueve(ev: PointerEvent): void {
    if ((ev.currentTarget as HTMLElement).hasPointerCapture(ev.pointerId)) this.rotar(this.tonoDesde(ev));
  }
  ruedaTecla(ev: KeyboardEvent): void {
    if (!this.puedeEditar) return;
    const paso = ev.shiftKey ? 15 : 5;
    const d = ({ ArrowRight: paso, ArrowUp: paso, ArrowLeft: -paso, ArrowDown: -paso } as Record<string, number>)[ev.key];
    if (d === undefined) return;
    ev.preventDefault();
    this.rotar((oDe(this.colorVisible('principal')).h + d + 360) % 360);
  }

  // ───────────────────────────────────────────────────────────── la vista previa
  ponerVista(v: 'claro' | 'comparar' | 'oscuro'): void {
    this.vista = v;
    this.corte = v === 'claro' ? 100 : v === 'oscuro' ? 0 : (this.corte <= 0 || this.corte >= 100 ? 50 : this.corte);
  }
  private corteDesde(ev: PointerEvent, capas: HTMLElement): void {
    const r = capas.getBoundingClientRect();
    this.corte = Math.min(100, Math.max(0, (ev.clientX - r.left) / r.width * 100));
  }
  corteAbajo(ev: PointerEvent, capas: HTMLElement): void {
    (ev.currentTarget as HTMLElement).setPointerCapture(ev.pointerId);
    this.corteDesde(ev, capas);
  }
  corteMueve(ev: PointerEvent, capas: HTMLElement): void {
    if ((ev.currentTarget as HTMLElement).hasPointerCapture(ev.pointerId)) this.corteDesde(ev, capas);
  }
  corteTecla(ev: KeyboardEvent): void {
    const d = ({ ArrowRight: 5, ArrowLeft: -5 } as Record<string, number>)[ev.key];
    if (d === undefined) return;
    ev.preventDefault();
    this.corte = Math.min(100, Math.max(0, this.corte + d));
  }

  // ───────────────────────────────────────────────────────────── recalcular
  private estilo(t: Tokens): string {
    return Object.keys(t).map((k) => `--pt-${k}:${t[k]}`).join(';');
  }
  private celda(fg: string, bg: string): Celda {
    const r = contraste(fg, bg);
    return { fg, bg, ratio: r.toFixed(1).replace('.', ','), nivel: r >= 4.5 ? 'bien' : r >= 3 ? 'justo' : 'mal' };
  }

  private recalcular(): void {
    this.juegos = juegosDe(this.preset, this.colores);
    this.estiloClaro = this.estilo(this.juegos.claro);
    this.estiloOscuro = this.estilo(this.juegos.oscuro);

    const c = this.juegos.claro, o = this.juegos.oscuro;
    const pares: [string, string, string][] = [
      ['Letra del botón principal', 'primary-foreground', 'primary'],
      ['Letra de la barra', 'sidebar-foreground', 'sidebar'],
      ['Renglón activo del menú', 'sidebar-activo-foreground', 'sidebar-activo'],
      ['Texto secundario', 'muted-foreground', 'card'],
      ['Ícono de la marca', 'marca-foreground', 'marca'],
    ];
    this.pruebas = pares.map(([etq, f, b]) => ({
      etq, claro: this.celda(c[f], c[b]), oscuro: this.celda(o[f], sobre(o[b], o['background'])),
    }));

    const notas: Nota[] = [{ aviso: false, texto: 'La letra la escoge el sistema: sobre un color oscuro va clara y sobre uno claro va oscura. El mínimo para leer bien es 4,5 a 1.' }];
    if (this.preset !== 'principal') {
      const pz = zona(oDe(this.colores.principal)), az = zona(oDe(this.colores.acento));
      if (pz) notas.push({ aviso: true, texto: `El principal cae en el ${pz.nombre}. En el portal, un botón de ese color se puede leer como un estado. Si puedes, mueve el tono fuera de esa marca.` });
      if (az) notas.push({ aviso: true, texto: this.preset.startsWith('creditotal')
        ? 'El naranja de CrediTotal es el mismo ámbar de «atención». Por eso en este tema va solo en la marca, nunca en algo que parezca un estado.'
        : `El acento cae en el ${az.nombre}. Va solo en la marca, pero los que te proponemos esquivan los colores de estado.` });
      for (const n of this.juegos.notas) notas.push({ aviso: false, texto: n });
    }
    this.notas = notas;

    if (this.personalizado) {
      this.acentos = proponerAcentos(this.colores.principal);
      this.bases = proponerBases(this.colores.principal);
    }

    for (const k of ['principal', 'acento', 'base', 'barra', 'fondo', 'panel'] as Clave[]) {
      const v = this.colorVisible(k);
      this.visibles[k] = v;
      if (this.enfocado !== k) this.hex[k] = v;
      const t = oDe(v);
      this.tonos[k] = t.c < 0.03 ? 'sin tono' : `${Math.round(t.h)}°`;
    }
    // la barra no dice su tono: dice qué letra le puso el sistema
    const letra = this.juegos.claro['sidebar-foreground'];
    this.tonos.barra = contraste(letra, '#FFFFFF') > contraste(letra, '#000000') ? 'letra oscura' : 'letra clara';
    const V = this.preset === 'principal' ? PRINCIPAL.colores : this.colores;
    this.idGuardadoActivo = this.personalizado
      ? (this.temasGuardados.find((t) => mismosColores(t.colores, this.colores))?._id ?? null)
      : null;
    this.atajosBarra = opcionesBarra(V);
    this.iBarra = this.atajosBarra.findIndex((o) => o.hex === V.barra);
    this.atajosFondo = opcionesFondo(V);
    this.iFondo = this.atajosFondo.findIndex((o) => o.hex === V.fondo);
    this.tonos.fondo = this.iFondo >= 0 ? this.atajosFondo[this.iFondo].nombre.toLowerCase() : this.tonos.fondo;
    this.atajosPanel = opcionesPanel(V);
    this.iPanel = this.atajosPanel.findIndex((o) => o.hex === V.panel);
    const letraPanel = this.juegos.claro['panel-ingreso-foreground'];
    this.tonos.panel = contraste(letraPanel, '#FFFFFF') > contraste(letraPanel, '#000000') ? 'letra oscura' : 'letra clara';

    const p = oDe(this.colorVisible('principal')), a = oDe(this.colorVisible('acento'));
    const [px, py] = this.punto(p.h, 50), [ax, ay] = this.punto(a.h, 50);
    this.puntoP = p.c < 0.03 ? null : { x: px, y: py, color: this.colorVisible('principal') };
    this.puntoA = a.c < 0.03 ? null : { x: ax, y: ay, color: this.colorVisible('acento') };
    this.tono = p.c < 0.03 ? '—' : `${Math.round(p.h)}°`;
    this.tonoValor = Math.round(p.h);
  }

  // ───────────────────────────────────────────────────────────── guardar
  guardar = async (): Promise<void> => {
    if (!this.puedeEditar || this.guardando || this.sinCambios) return;
    this.guardando = true;
    this.resultado = null;
    try {
      const theme = temaParaGuardar(this.preset, this.colores, this.juegos, this.logo, this.login);
      const rep = await this._merchant.setTheme(this.codigo, theme);
      this.guardado = temaGuardado(rep?.merchant?.theme ?? theme);
      this.resultado = {
        ok: true,
        texto: `Guardado. ${this.nombre} ve el tema ${NOMBRE_PRESET[this.preset]} en la próxima pantalla que abra en el portal.`,
      };
    } catch (e: any) {
      this.resultado = { ok: false, texto: e?.error?.detalle || e?.error?.msg || 'No se pudo guardar el tema.' };
    } finally {
      this.guardando = false;
    }
  };

  descartar(): void {
    this.preset = this.guardado.preset;
    this.colores = { ...this.guardado.colores };
    this.logo = this.guardado.logo;
    this.login = this.guardado.login;
    this.imagenSubida = null;
    this.errorLogo = null;
    this.acentoManual = true; this.baseManual = true;
    this.resultado = null;
    this.recalcular();
  }
}
